// extracted by mini-css-extract-plugin
export var isVoid = "PickemPick-module--isVoid--5419d";
export var marketNameAndPoints = "PickemPick-module--marketNameAndPoints--e2915";
export var name = "PickemPick-module--name--d0a7b";
export var outcomeIcon = "PickemPick-module--outcomeIcon--23de9";
export var replacement = "PickemPick-module--replacement--40213";